export default {
  meta: {
    title: $localize`:@@meta.bonus-wheel.title:Барабан Призов → CSFAIL`,
    description: $localize`:@@meta.bonus-wheel.description:Лови крутые призы в барабане!`
  }
};